/* tslint:disable */
import * as React from "react";

import { ScreenReaderOnly } from '../../components/Accessibility/ScreenReaderOnly';

const SvgLogoTd: React.FunctionComponent<
  React.SVGAttributes<SVGElement>
> = props => (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={65}
      width={419}
      viewBox="0 0 419 65"
      aria-hidden='true'
      {...props}
    >
      <title>{`TD Logo`}</title>
      <path d="M18.167 7.953H0V1.75h43.932v6.202H25.766V64.2h-7.6V7.953M66.747 58c16.071 0 24.107-9.608 24.107-24.894v-.697c0-14.412-6.987-24.544-24.194-24.544h-8.472V58zM50.59 1.75h16.508c21.486 0 31.617 13.277 31.617 30.659v.784c0 17.296-9.957 31.008-31.792 31.008H50.589V1.75M126.422 1.75h36.509v6.203h-28.91v22.096h22.535v6.203h-22.535V64.2h-7.599V1.75M170.617 18.52h7.25V64.2h-7.25zM170.356.006h7.773v8.733h-7.773V.005M192.716 52.76V24.635h-6.55v-6.114h6.55V8.127h7.25v10.394h10.654v6.114h-10.655V52.06c0 4.454 2.008 6.638 5.676 6.638 2.272 0 4.019-.349 5.59-.96v6.114c-1.484.523-3.231.96-6.2.96-8.298 0-12.315-4.891-12.315-12.052M239.812 1.75h7.599V58h28.56v6.2h-36.159V1.75M316.148 41.754v-.612c0-10.568-5.852-17.38-14.935-17.38-9.172 0-14.936 6.812-14.936 17.293v.7c0 10.392 5.676 17.205 14.936 17.205 9.171 0 14.935-6.9 14.935-17.206zm-37.381 0v-.7c0-13.712 9.518-23.32 22.446-23.32 12.926 0 22.447 9.52 22.447 23.234v.699c0 13.8-9.521 23.32-22.535 23.32-13.013 0-22.358-9.87-22.358-23.233M365.41 41.667v-.7c0-11.703-5.678-17.206-13.887-17.206-8.386 0-14.063 6.377-14.063 17.468v.7c0 11.528 6.29 17.031 13.45 17.031 7.774 0 14.5-5.59 14.5-17.293zm-35.46.61v-.698c0-13.975 9.345-23.845 20.874-23.845 7.075 0 11.704 3.495 14.324 7.95V18.52h7.248V64.2h-7.248v-7.687c-2.62 4.455-8.91 8.473-15.023 8.473-10.917 0-20.176-8.473-20.176-22.71M381.308 18.52h7.25v7.25c2.095-4.28 7.16-8.036 14.671-8.036 9.435 0 16.072 5.154 16.072 18.43v28.037h-7.249V35.64c0-8.036-3.407-11.617-10.744-11.617-6.725 0-12.75 4.28-12.75 12.49v27.688h-7.25V18.52"/>
    </svg>
    <ScreenReaderOnly>TD Logo</ScreenReaderOnly>
  </>
);
export default SvgLogoTd;
